module.exports = __webpack_public_path__ + "img/24_36.454f9e38.png";